import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'antd';

import { AnalysisPlotsContainer, AnalysisPlotsTitle, StyledLine, GroupedLine } from './style';

export const WcoXmlWebAnalyticsTabContent = ({ data }) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (!data) return;
  }, [data]);

  function sortObject(obj) {
    return Object.keys(obj)
      .sort()
      .reduce(function (result, key) {
        result[key] = obj[key];
        return result;
      }, {});
  }
  const sourceDataset = data ? Object.values(sortObject(data)) : [];

  let importExportDataset = [];
  let sorterDataset = [];
  let globalDataset = [];
  sourceDataset.map(row => {
    importExportDataset.push({
      date: row.date,
      value: row.IMPORT,
      category: 'IMPORT',
    });
    importExportDataset.push({
      date: row.date,
      value: row.EXPORT,
      category: 'EXPORT',
    });
    globalDataset.push({
      date: row.date,
      value: row.global_processed,
      category: 'global_processed',
    });
    globalDataset.push({
      date: row.date,
      value: row.count,
      category: 'files_processed',
    });
    globalDataset.push({
      date: row.date,
      value: row.line_items_processed,
      category: 'line_items_processed',
    });
    ['WAW', 'OZR', 'WRO', 'GDN', 'POZ', 'SZZ', 'KTW'].map(sorter => {
      sorterDataset.push({
        date: row.date,
        value: row[sorter],
        category: sorter,
      });
    });
  });

  const globaltConfig = {
    data: globalDataset,
    isStack: true,
    xField: 'date',
    yField: 'value',
    seriesField: 'category',
    slider: {},
  };

  const importExportConfig = {
    data: importExportDataset,
    isStack: true,
    xField: 'date',
    yField: 'value',
    seriesField: 'category',
    slider: {},
  };

  const sorterConfig = {
    data: sorterDataset,
    isStack: true,
    xField: 'date',
    yField: 'value',
    seriesField: 'category',
    slider: {},
  };

  return (
    <AnalysisPlotsContainer>
      <Row>
        <Col span={24}>
          <AnalysisPlotsTitle>{t('myCompanies.generalAnalytics')}</AnalysisPlotsTitle>
          <StyledLine {...globaltConfig} />
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          <AnalysisPlotsTitle>{t('myCompanies.generalAnalytics')}</AnalysisPlotsTitle>
          <GroupedLine {...importExportConfig} />
        </Col>
        <Col span={12}>
          <AnalysisPlotsTitle>{t('myCompanies.generalAnalytics')}</AnalysisPlotsTitle>
          <GroupedLine {...sorterConfig} />
        </Col>
      </Row>
    </AnalysisPlotsContainer>
  );
};
